<template>
  <div class="print-wrapper w-full p-4 ">
    <!-- Print Button -->
    <div class="mb-4 print-hidden">
      <button @click="handlePrint" class="bg-blue-600 text-white px-4 py-2 rounded">
        طباعة الطلب
      </button>
    </div>

    <!-- Printable Content -->
    <div ref="componentRef" class="print-container">
      <h2 class="text-xl font-bold mb-4">تفاصيل الطلب</h2>

      <table class="w-full border border-collapse text-right">
        <tbody>
          <tr>
            <th class="border px-4 py-2">رقم الطلب</th>
            <td class="border px-4 py-2">{{ order.order_num }}</td>
          </tr>
          <tr>
            <th class="border px-4 py-2">اسم المستخدم</th>
            <td class="border px-4 py-2">{{ order.user_name }}</td>
          </tr>
          <tr>
            <th class="border px-4 py-2">المنتجات</th>
            <td class="border px-4 py-2">{{ order.products }}</td>
          </tr>
          <tr>
            <th class="border px-4 py-2">إجمالي السعر</th>
            <td class="border px-4 py-2">{{ order.total_price }}</td>
          </tr>
          <tr>
            <th class="border px-4 py-2">تاريخ الطلب</th>
            <td class="border px-4 py-2">{{ order.order_date }}</td>
          </tr>
          <tr>
            <th class="border px-4 py-2">وقت الاستلام</th>
            <td class="border px-4 py-2">{{ order.receive_date }} , {{ order.receive_time }}</td>
          </tr>
     
          <tr>
            <th class="border px-4 py-2">حالة الدفع</th>
            <td class="border px-4 py-2">
              <span :class="order.payment_status ? 'text-green-600' : 'text-red-600'">
                {{ order.payment_status ? 'مدفوع' : 'غير مدفوع' }}
              </span>
            </td>
          </tr>
          <tr v-if="order.statusText">
            <th class="border px-4 py-2">الحالة</th>
            <td class="border px-4 py-2">{{ order.statusText }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup >
import { ref } from 'vue'
import { useVueToPrint } from 'vue-to-print'

const componentRef = ref()
const { handlePrint } = useVueToPrint({
  content: componentRef,
  documentTitle: 'تفاصيل الطلب'
})

const order = {
  id: 352,
  order_num: '#906727',
  user_name: 'Abdullah Amer',
  products: 'مانجو',
  total_price: '1.15 ريال',
  order_date: '2025 - أبريل - 25',
  receive_date: '2025 - أبريل - 26',
  receive_time: '00:15',
  payment_status: true,
  status: null,
  statusText: null
}
</script>

<style scoped>
.print-wrapper {
  max-width: 700px;
  margin: 0 auto;
  direction: rtl;
  font-family: 'Tajawal', sans-serif;
}
.print-hidden {
  display: block;
}
@media print {
  .print-hidden {
    display: none !important;
  }
}
</style>
